import ArrowDown from './svg/arrow-down.svg';
import ArrowLeft from './svg/arrow-left.svg';
import Check from './svg/check.svg';
import CheckboxChecked from './svg/checkbox-checked.svg';
import CheckboxIndeterminate from './svg/checkbox-indeterminate.svg';
import CheckboxUnchecked from './svg/checkbox-unchecked.svg';
import ChevronLeft from './svg/chevron-left.svg';
import ChevronRight from './svg/chevron-right.svg';
import Close from './svg/close.svg';
import Copy from './svg/copy.svg';
import Delete from './svg/delete.svg';
import Download from './svg/download.svg';
import Edit from './svg/edit.svg';
import Filter from './svg/filter.svg';
import FirstPage from './svg/first-page.svg';
import FlipTriangle from './svg/flip-triangle.svg';
import LastPage from './svg/last-page.svg';
import Loading from './svg/loading.svg';
import Menu from './svg/menu.svg';
import MinusCircle from './svg/minus-circle.svg';
import Minus from './svg/minus.svg';
import Pencil from './svg/pencil.svg';
import PlusCircle from './svg/plus-circle.svg';
import Plus from './svg/plus.svg';
import Print from './svg/print.svg';
import RadioChecked from './svg/radio-checked.svg';
import RadioUnchecked from './svg/radio-unchecked.svg';
import Save from './svg/save.svg';
import Search from './svg/search.svg';
import Undo from './svg/undo.svg';
import Upload from './svg/upload.svg';
import Warning from './svg/warning.svg';

const Icon = {
  ArrowDown,
  ArrowLeft,
  Check,
  CheckboxChecked,
  CheckboxIndeterminate,
  CheckboxUnchecked,
  ChevronLeft,
  ChevronRight,
  Close,
  Copy,
  Delete,
  Download,
  Edit,
  Filter,
  FirstPage,
  FlipTriangle,
  LastPage,
  Loading,
  Menu,
  Minus,
  MinusCircle,
  Pencil,
  Plus,
  PlusCircle,
  Print,
  RadioChecked,
  RadioUnchecked,
  Save,
  Search,
  Undo,
  Upload,
  Warning,
};

export default Icon;
